import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { AuthGuard } from '@/components/auth-guard';
import { ArticleWriterPage } from '@/features/articles/components';

function ArticleNewRoute(): ReactNode {
  // No `slug` prop → writer renders in NEW mode: an auto-generated
  // default slug populates the slug input, title/body live in client
  // state, and the explicit "Save draft" action POSTs to /articles
  // before redirecting here as `/articles/:slug/edit`.
  return (
    <AuthGuard>
      <ArticleWriterPage />
    </AuthGuard>
  );
}

export const Route = createFileRoute('/articles/new')({
  component: ArticleNewRoute,
});
